'use client';

import { useServerInsertedHTML } from 'next/navigation';
import { useRef } from 'react';

type DeferredStylesProps = {
    href: string;
};

export default function DeferredStyles({ href }: DeferredStylesProps) {
    const inserted = useRef(false);
    const activationScript = `(function(){var l=document.getElementById('site-main-styles');if(!l)return;var a=function(){l.media='all'};if(l.sheet){a()}else{l.addEventListener('load',a,{once:true})}})()`;
    const isDevelopment = process.env.NODE_ENV === 'development';

    useServerInsertedHTML(() => {
        if (inserted.current) return null;

        inserted.current = true;

        if (isDevelopment) {
            return <link id='site-main-styles' rel='stylesheet' href={href} />;
        }

        return (
            <>
                <link
                    id='site-main-styles'
                    rel='stylesheet'
                    href={href}
                    media='print'
                    data-estilos-diferidos='true'
                />
                <script
                    id='site-main-styles-loader'
                    dangerouslySetInnerHTML={{ __html: activationScript }}
                />
                <noscript>
                    <link rel='stylesheet' href={href} />
                </noscript>
            </>
        );
    });

    return null;
}
